export default function CtaSection() {
  return (
    <section className="relative h-[600px] overflow-hidden my-20 mx-8 rounded-[32px]">
      {/* Imagen de fondo */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1d3ef8a6d5ffad3e42998003466f6395.jpg"
          alt="Protege tu futuro"
          className="w-full h-full object-cover"
        />
        {/* Overlay oscuro */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Contenido */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-12 flex flex-col justify-between py-20">
        {/* Título superior izquierda */}
        <div className="max-w-2xl">
          <h2 className="text-7xl font-bold text-white leading-tight">
            protege tu futuro hoy
          </h2>
        </div>

        {/* Contenido inferior */}
        <div className="flex items-end justify-between">
          {/* Botón inferior izquierda */}
          <a 
            href="http://wa.me/524443289285"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-[#1a2332] px-8 py-4 rounded-full font-semibold hover:shadow-2xl transition-all flex items-center gap-4 group cursor-pointer whitespace-nowrap"
          >
            <span className="text-lg">Comienza Ahora</span>
            <div className="w-10 h-10 bg-[#1a2332] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </div>
          </a>

          {/* Texto inferior derecha */}
          <div className="max-w-md text-right">
            <p className="text-white text-2xl leading-relaxed">
              No esperes a que sea tarde.
            </p>
            <p className="text-white text-2xl leading-relaxed mt-2">
              La protección financiera comienza con una decisión.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
